import { useEffect, useRef, useState } from "react";

export const Buscador = ({
    setValorBuscador,
    valorBuscador
}) =>{
    const [ mostrarBuscador, setMostrarBuscador ] = useState(false);
    const inputBusqueda = useRef(null)
    const botonBuscar = useRef(null)

    useEffect(()=> {
        !mostrarBuscador && setValorBuscador('textoBuscador','')
    },[mostrarBuscador])
    return(
        <section key={'contenedorBusqueda'} className='absolute right-[40px]' style={{zIndex: 44}}>
            <section key={'contenedorInputBusqueda'} className="absolute w-[39px] active">
                {
                    mostrarBuscador && <input
                        ref={inputBusqueda}
                        id='divBtnBuscar'
                        className={ `visible text-white h-[30px] px-4 w-[180px] 
                            text-[13px] focus:outline-none focus:ring-1 focus:ring-blue-500 caret-input
                            absolute right-[9.8px] bg-[#27272a] rounded-tl-md rounded-bl-md border-[#171313] pl-[10px]
                            ${mostrarBuscador ? " translate-x-0 " : " translate-x-full "} transition-transform duration-1000 ease-in-out`
                        }
                        value={valorBuscador}
                        onChange={(e) => setValorBuscador('textoBuscador',e.target.value)}
                        type="text"
                        placeholder="Búsqueda"
                        autoComplete="off"
                        autoFocus={ true }
                    />
                }
            </section>
            <button
                ref={botonBuscar}
                className='absolute h-[30px] w-[30px] rounded-l-lg infoBusqueda bg-zinc-700 text-[#FFFFFF]'
                onClick={() => setMostrarBuscador(!mostrarBuscador)}
            >
                <i className='fa fa-search '></i>
            </button>
        </section>
    )
} 